@if (group && field) {
  <ion-item
    [id]="field.name"
    [formGroup]="group"
    [ngClass]="field.class"
    class="Input"
  >
    <ion-input
      class="Input"
      color="primary"
      [label]="field.label"
      labelPlacement="floating"
      [formControlName]="field.name || 'noName'"
      [type]="field.inputType || 'text'"
      (ionFocus)="scrollIntoView()"
      [ngClass]="field.class"
    ></ion-input>
    <!-- Validation Errors -->
    @for (validation of field.validations; track validation) {
      @if (
        group.get(field.name || 'noName')?.hasError(validation.name) &&
        (group.get(field.name || 'noName')?.touched ||
          group.get(field.name || 'noName')?.dirty)
      ) {
        <div class="validation-error">
          <ion-text color="danger" [innerHTML]="validation.message"></ion-text>
        </div>
      }
    }
  </ion-item>
}
